/* eslint-disable */

import React, { useEffect } from "react";

import QuizAnswerButton from "../../../ui-components/quiz-answer-button/quiz-answer-button.tsx";
import RaindropBackButtonPanel from "../../../ui-components/raindrop-back-button-panel/raindrop-back-button-panel.tsx";

const CountDot = ({ isComplete = false, isCurrent = false }) => {
  let tailwindBackground = "bg-color-background-tertiary";
  let tailwindBorder = "border-color-border-tertiary";
  let tailwindPadding = "w-3 h-3";

  if (isComplete) {
    tailwindBackground = "bg-color-background-green";
    tailwindBorder = "border-color-border-green";
  }

  if (isCurrent) {
    tailwindPadding = "w-4 h-4";
  }

  return (
    <div
      className={`transition-all rounded-full border ${tailwindPadding} ${tailwindBackground} ${tailwindBorder}`}
    />
  );
};

const ComponentProgressBar = ({ currentIndex = 0, totalLength = 10 }) => {
  const progressPercentage = ((currentIndex + 1) / (totalLength + 1)) * 100;

  return (
    <div className="flex flex-col w-full dark:bg-color-dark-background-secondary bg-color-background-tertiary max-w-sm rounded-full justify-center p-2 relative">
      <div
        className="flex bg-color-raindrop-primary h-6 rounded-full w-full transition-all "
        style={{ width: `${progressPercentage}%` }}
      />
    </div>
  );
};

const ComponentCountDisplay = ({ currentIndex = 0, totalLength = 10 }) => {
  const dots = Array(totalLength).fill(0);
  return (
    <div className="flex flex-row w-full gap-1 justify-center flex-wrap items-center">
      {dots.map((_, index) => (
        <CountDot
          isComplete={index < currentIndex}
          isCurrent={index == currentIndex}
        />
      ))}
    </div>
  );
};

const ComponentCardsDisplay = ({
  currentCards,
  onClickCard = (a, b) => {},
  memoryData,
  currentIndex,
  highlightDuration,
}) => {
  return (
    <div className="flex flex-row flex-wrap w-full gap-2 items-center justify-center">
      {currentCards.map((card, index) => (
        <QuizAnswerButton
          key={`${card.title}-${index}`}
          onClick={() => onClickCard(card, index)}
          title={card.title}
          isCorrectAnswer={
            card.title === memoryData.memoryObjects[currentIndex].title
          }
          highlightDuration={highlightDuration}
        />
      ))}
    </div>
  );
};

const RaindropBombsAway = ({ values, setIsFocusedOnCenter = (x) => {} }) => {
  const dataColours = {
    topic: "Colours",
    memoryObjects: [
      {
        title: "Red",
      },
      {
        title: "Orange",
      },
      {
        title: "Yellow",
      },
      {
        title: "Green",
      },
      {
        title: "Blue",
      },
      {
        title: "Indigo",
      },
      {
        title: "Violet",
      },
    ],
  };

  const dataPlanets = {
    topic: "Planets",
    memoryObjects: [
      {
        title: "The Sun",
      },
      {
        title: "Mercury",
      },
      {
        title: "Venus",
      },
      {
        title: "Earth",
      },
      {
        title: "Mars",
      },
      {
        title: "Jupiter",
      },
      {
        title: "Saturn",
      },
      {
        title: "Uranus",
      },
      {
        title: "Neptune",
      },
    ],
  };

  const dataHistoricalEvents = {
    topic: "Historical events",
    memoryObjects: [
      {
        title: "Wright Brothers' First Flight",
        data: "1903",
        description: "Birth of modern aviation.",
      },
      {
        title: "Start of World War I",
        data: "1914",
        description:
          "Major geopolitical reshaping; collapse of empires (Ottoman, Austro-Hungarian, German, Russian).",
      },
      {
        title: "Russian Revolution",
        data: "1917",
        description:
          "Led to the formation of the Soviet Union and inspired global communist movements.",
      },

      {
        title: "Treaty of Versailles Signed",
        data: "1919",
        description: "Punitive terms toward Germany laid groundwork for WWII.",
      },
      {
        title: "U.S. Women's Suffrage (19th Amendment)",
        data: "1920",
        description:
          "Part of a global wave of women gaining the right to vote.",
      },
      {
        title: "Start of the Great Depression",
        data: "1929",
        description: "Worldwide economic collapse and social upheaval.",
      },
      {
        title: "Adolf Hitler Comes to Power in Germany",
        data: "1933",
        description: "Rise of fascism; key precursor to WWII.",
      },
      {
        title: "Start of World War II",
        data: "1939",
        description: "Most destructive conflict in human history.",
      },
      {
        title: "Atomic Bombing of Hiroshima and Nagasaki",
        data: "1945",
        description: "Brought about Japan's surrender; began the nuclear age.",
      },
      {
        title: "Founding of the United Nations",
        data: "1945",
        description:
          "Created to prevent future world wars and foster international },cooperation.",
      },
      {
        title: "India Gains Independence from Britain",
        data: "1947",
        description:
          "Key moment in global decolonization; led to partition with },Pakistan.",
      },
      {
        title: "Creation of the State of Israel",
        data: "1948",
        description: "Set off enduring conflict in the Middle East.",
      },
      {
        title: "People's Republic of China Established",
        data: "1949",
        description:
          "One of the most populous nations turns communist; shifts Cold War },dynamics.",
      },
      {
        title: "Korean War Begins",
        data: "1950",
        description:
          "First armed conflict of the Cold War; Korea remains divided.",
      },
      {
        title: "Cuban Missile Crisis",
        data: "1962",
        description: "Closest the world came to full-scale nuclear war.",
      },
      {
        title: "Civil Rights Act Passed in the U.S.",
        data: "1964",
        description:
          "Landmark legislation against racial segregation and discrimination.},",
      },
      {
        title: "The Moon Landing",
        data: "1969",
        description:
          "First humans on the Moon; symbolic Cold War victory for the U.S.",
      },
      {
        title: "Fall of Saigon / End of Vietnam War",
        data: "1975",
        description: "U.S. military defeat; major Cold War turning point.",
      },
      {
        title: "Fall of the Berlin Wall",
        data: "1989",
        description:
          "Collapse of Eastern Bloc regimes; symbolic end of Cold War.",
      },
      {
        title: "Dissolution of the Soviet Union",
        data: "1991",
        description:
          "End of the Cold War; U.S. emerges as the sole superpower.",
      },
    ],
  };

  const dataUSPresidents = {
    memoryObjects: [
      { title: "George Washington" },
      { title: "John Adams" },
      { title: "Thomas Jefferson" },
      { title: "James Madison" },
      { title: "James Monroe" },
      { title: "John Quincy Adams" },
      { title: "Andrew Jackson" },
      { title: "Martin Van Buren" },
      { title: "William Henry Harrison" },
      { title: "John Tyler" },
      { title: "James K. Polk" },
      { title: "Zachary Taylor" },
      { title: "Millard Fillmore" },
      { title: "Franklin Pierce" },
      { title: "James Buchanan" },
      { title: "Abraham Lincoln" },
      { title: "Andrew Johnson" },
      { title: "Ulysses S. Grant" },
      { title: "Rutherford B. Hayes" },
      { title: "James A. Garfield" },
      { title: "Chester A. Arthur" },
      { title: "Grover Cleveland" },
      { title: "Benjamin Harrison" },
      { title: "Grover Cleveland" },
      { title: "William McKinley" },
      { title: "Theodore Roosevelt" },
      { title: "William Howard Taft" },
      { title: "Woodrow Wilson" },
      { title: "Warren G. Harding" },
      { title: "Calvin Coolidge" },
      { title: "Herbert Hoover" },
      { title: "Franklin D. Roosevelt" },
      { title: "Harry S. Truman" },
      { title: "Dwight D. Eisenhower" },
      { title: "John F. Kennedy" },
      { title: "Lyndon B. Johnson" },
      { title: "Richard Nixon" },
      { title: "Gerald Ford" },
      { title: "Jimmy Carter" },
      { title: "Ronald Reagan" },
      { title: "George H. W. Bush" },
      { title: "Bill Clinton" },
      { title: "George W. Bush" },
      { title: "Barack Obama" },
      { title: "Donald J. Trump" },
      { title: "Joe Biden" },
      { title: "Donald J. Trump" },
    ],
  };

  const dataHindiDaysOfTheWeek = {
    title: "Days of the Week in Hindi",
    memoryObjects: [
      { title: "सोमवार" }, // Somvaar (Monday)
      { title: "मंगलवार" }, // Mangalvaar (Tuesday)
      { title: "बुधवार" }, // Budhvaar (Wednesday)
      { title: "गुरुवार" }, // Guruvaar (Thursday)
      { title: "शुक्रवार" }, // Shukrvaar (Friday)
      { title: "शनिवार" }, // Shanivaar (Saturday)
      { title: "रविवार" }, // Ravivaar (Sunday)
    ],
  };

  const dataTest = {
    title: "Test",
    memoryObjects: [
      { title: "A" },
      { title: "B" },
      { title: "B" },
      { title: "B" },
      { title: "B" },
      { title: "B" },
      { title: "B" },
      { title: "B" },
      { title: "B" },
      { title: "B" },
      { title: "B" },
      { title: "B" },
      { title: "B" },
      { title: "B" },
      { title: "B" },
      { title: "B" },
      { title: "B" },
      { title: "B" },
      { title: "B" },
      { title: "B" },
      { title: "B" },
      { title: "B" },
      { title: "B" },
      { title: "B" },
      { title: "B" },
      { title: "B" },
      { title: "B" },
      { title: "B" },
      { title: "B" },
      { title: "B" },
      { title: "B" },
      { title: "B" },
      { title: "B" },
      { title: "B" },
      { title: "B" },
      { title: "B" },
      { title: "B" },
    ],
  };

  const [memoryData, setMemoryData] = React.useState(dataHistoricalEvents);

  const [retryCount, setRetryCount] = React.useState(0);

  const [currentIndex, setCurrentIndex] = React.useState(0);

  const [currentCards, setCurrentCards] = React.useState<{ title: string }[]>(
    []
  );

  const highlightDuration = 500;

  useEffect(() => {
    const randomSubset = memoryData.memoryObjects
      .filter((_, index) => index !== currentIndex)
      .sort(() => Math.random() - 0.5)
      .slice(0, 5);

    const shuffledCards = [
      memoryData.memoryObjects[currentIndex],
      ...randomSubset,
    ].sort(() => Math.random() - 0.5);

    const timeout = setTimeout(() => {
      console.log("Shuffled cards", shuffledCards);
      setCurrentIndex(0);
      setCurrentCards(shuffledCards);
    }, highlightDuration);

    return () => {
      clearTimeout(timeout);
    };
  }, [memoryData, retryCount]);

  // Darken the background
  useEffect(() => {
    setIsFocusedOnCenter(true);
    return () => {
      setIsFocusedOnCenter(false);
    };
  }, []);

  const onClickCard = (memoryObject, index) => {
    const isCorrect =
      memoryObject.title === memoryData.memoryObjects[currentIndex].title;

    console.log("isCorrect", isCorrect);
    if (!isCorrect) {
      setRetryCount((prevValue) => prevValue + 1);
      return;
    }

    const isLastCard = currentIndex === memoryData.memoryObjects.length - 1;

    if (isLastCard) {
      alert("You have completed the game!");
      setCurrentIndex(0);
      setRetryCount(0);
      return;
    }

    const newCurrentIndex = currentIndex + 1;
    const newCorrectMemoryObject = memoryData.memoryObjects[newCurrentIndex];
    const newCurrentCards = [...currentCards];
    const unusedMemoryObjects = memoryData.memoryObjects.filter(
      (obj) => !newCurrentCards.includes(obj)
    );
    const randomMemoryObject =
      unusedMemoryObjects[
        Math.floor(Math.random() * unusedMemoryObjects.length)
      ];
    newCurrentCards[index] = randomMemoryObject;

    if (!newCurrentCards.includes(newCorrectMemoryObject)) {
      newCurrentCards[index] = newCorrectMemoryObject;
    }

    const timeout = setTimeout(() => {
      setCurrentCards(newCurrentCards);
      setCurrentIndex((prevValue) => prevValue + 1);
    }, highlightDuration);
  };

  return (
    <div className="flex flex-col h-full w-full items-center gap-6 pt-6">
      <RaindropBackButtonPanel />
      <div className="flex flex-col h-full items-center gap-6 justify-center">
        <ComponentProgressBar
          currentIndex={currentIndex}
          totalLength={memoryData.memoryObjects.length}
        />
        {/* <ComponentCountDisplay
        currentIndex={currentIndex}
        totalLength={memoryData.memoryObjects.length}
      /> */}
        <ComponentCardsDisplay
          currentCards={currentCards}
          currentIndex={currentIndex}
          highlightDuration={highlightDuration}
          memoryData={memoryData}
          onClickCard={onClickCard}
        />
      </div>
    </div>
  );
};

export default RaindropBombsAway;
